export interface ScoringPhoto {
  photoType: 'passportMain' | 'placeRegistration' | 'selfie' | 'driverLicense' | 'driverLicenseBack';
  path: string;
  url: string;
}

export interface MobileBffSendToKycRequestDto {
  photos: ScoringPhoto[];
}
